/**
 * Canonical reporting frequency (download granularity) definitions shared by
 * the asset and system hybrid reporting components.
 *
 * These were previously duplicated inline in each component, which allowed them
 * to drift — the asset report lost its "5 Minutes" option while the system
 * report kept it. Defining them once here keeps the two in lockstep.
 *
 * The values must match the frequencies accepted by the Timeseries reporting
 * API (`FREQUENCY_MAP` in the backend aggregator): 5min, hourly, daily, weekly,
 * monthly.
 */

export type Frequency = "5min" | "hourly" | "daily" | "weekly" | "monthly"

export interface FrequencyOption {
  value: Frequency
  label: string
}

export const FREQUENCY_OPTIONS: FrequencyOption[] = [
  { value: "5min", label: "5 Minutes" },
  { value: "hourly", label: "Hourly" },
  { value: "daily", label: "Daily" },
  { value: "weekly", label: "Weekly" },
  { value: "monthly", label: "Monthly" },
]

/** Default frequency used when a report first loads. */
export const DEFAULT_FREQUENCY: Frequency = "daily"
